// ProfileCardPreviewRenderer — drop-in component that takes a message
// body (plain string) and renders zero or more ProfileCard previews
// stacked beneath it. Lives next to the chat bubble; never replaces it.
//
// Designed to be the smallest possible attachment point in
// CustomMessage.js — caller does:
//
//   <div className="msg-bubble">{message.text}</div>
//   <ProfileCardPreviewRenderer text={message.text} />
//
// Zero side-effects when the text has no profile links (early exit on
// `hasProfileLink`) so non-matching messages cost ~nothing.

import React from "react";

import { detectProfileLinks, hasProfileLink } from "../../utils/profileLinkDetector";
import ProfileCard from "./ProfileCard";

export default function ProfileCardPreviewRenderer({ text }) {
  // Cheap short-circuit for 99% of messages.
  if (!hasProfileLink(text)) return null;

  const matches = detectProfileLinks(text);
  if (matches.length === 0) return null;

  return (
    <div
      className="tp-card-chat"
      // Stack consecutive cards in a single column with a small gap so
      // a "compare these three" message reads naturally.
      style={{ display: "flex", flexDirection: "column", gap: 8 }}
    >
      {matches.map((m) => (
        <ProfileCard
          key={`${m.type}:${m.id}:${m.index}`}
          type={m.type}
          id={m.id}
          fullUrl={m.fullUrl}
        />
      ))}
    </div>
  );
}
